var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex-1" }, [
    _c("div", { staticClass: "flex-1" }, [
      _c("div", { staticClass: "py-6" }, [
        _c("h3", { staticClass: "text-lg font-medium mb-3" }, [
          _vm._v("Step 2 of 9: Risks and Alerts"),
        ]),
        _c("div", { staticClass: "grid grid-cols-1 gap-3" }, [
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v(" Fall Risk "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      name: "fall_risk",
                      getParentCustom: "clientWidth",
                      placeholder: "Select",
                      options: [
                        { label: "Yes", value: "yes" },
                        { label: "No", value: "no" },
                      ],
                      inputClass: "w-full",
                    },
                    on: { input: (val) => _vm.updateField("fall_risk", val) },
                    model: {
                      value: _vm.localFormData.fall_risk,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "fall_risk", $$v)
                      },
                      expression: "localFormData.fall_risk",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v(" Infectious Diseases "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "infectious_diseases",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("infectious_diseases", val),
                    },
                    model: {
                      value: _vm.localFormData.infectious_diseases,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "infectious_diseases", $$v)
                      },
                      expression: "localFormData.infectious_diseases",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v(" Substance Use Considerations "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "substance_use_considerations",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("substance_use_considerations", val),
                    },
                    model: {
                      value: _vm.localFormData.substance_use_considerations,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localFormData,
                          "substance_use_considerations",
                          $$v
                        )
                      },
                      expression: "localFormData.substance_use_considerations",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._m(0),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v(" Food "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "allergy_food",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) => _vm.updateField("allergy_food", val),
                    },
                    model: {
                      value: _vm.localFormData.allergy_food,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "allergy_food", $$v)
                      },
                      expression: "localFormData.allergy_food",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v(" Medication "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "allergy_medication",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("allergy_medication", val),
                    },
                    model: {
                      value: _vm.localFormData.allergy_medication,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "allergy_medication", $$v)
                      },
                      expression: "localFormData.allergy_medication",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v(" Environmental "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "allergy_environmental",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("allergy_environmental", val),
                    },
                    model: {
                      value: _vm.localFormData.allergy_environmental,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localFormData,
                          "allergy_environmental",
                          $$v
                        )
                      },
                      expression: "localFormData.allergy_environmental",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._m(1),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v(" Do Not Resuscitate (DNR) Order "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      name: "dnr_order",
                      getParentCustom: "clientWidth",
                      placeholder: "Select",
                      options: [
                        { label: "Yes", value: "yes" },
                        { label: "No", value: "no" },
                      ],
                      inputClass: "w-full",
                    },
                    on: { input: (val) => _vm.updateField("dnr_order", val) },
                    model: {
                      value: _vm.localFormData.dnr_order,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "dnr_order", $$v)
                      },
                      expression: "localFormData.dnr_order",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v(" Copy Attached "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      name: "dnr_copy_attached",
                      getParentCustom: "clientWidth",
                      placeholder: "Select",
                      options: [
                        { label: "Yes", value: "yes" },
                        { label: "No", value: "no" },
                      ],
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) => _vm.updateField("dnr_copy_attached", val),
                    },
                    model: {
                      value: _vm.localFormData.dnr_copy_attached,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "dnr_copy_attached", $$v)
                      },
                      expression: "localFormData.dnr_copy_attached",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._m(2),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v(" Description "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "precautions_description",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("precautions_description", val),
                    },
                    model: {
                      value: _vm.localFormData.precautions_description,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localFormData,
                          "precautions_description",
                          $$v
                        )
                      },
                      expression: "localFormData.precautions_description",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v(" Related Notes "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormTextarea", {
                    attrs: {
                      rows: 3,
                      customBorderClass: "borderTen",
                      name: "precautions_related_notes",
                      placeholder: "Type here",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("precautions_related_notes", val),
                    },
                    model: {
                      value: _vm.localFormData.precautions_related_notes,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localFormData,
                          "precautions_related_notes",
                          $$v
                        )
                      },
                      expression: "localFormData.precautions_related_notes",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v(" General Notes "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormTextarea", {
                    attrs: {
                      rows: 3,
                      customBorderClass: "borderTen",
                      name: "precautions_general_notes",
                      placeholder: "Type here",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("precautions_general_notes", val),
                    },
                    model: {
                      value: _vm.localFormData.precautions_general_notes,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localFormData,
                          "precautions_general_notes",
                          $$v
                        )
                      },
                      expression: "localFormData.precautions_general_notes",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-span-2" }, [
      _c("h5", { staticClass: "text-base font-medium" }, [_vm._v("Allergies")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-span-2" }, [
      _c("h5", { staticClass: "text-base font-medium" }, [
        _vm._v("Do Not Resuscitate (DNR) Order"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-span-2" }, [
      _c("h5", { staticClass: "text-base font-medium" }, [
        _vm._v("Precautions"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }